import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { LanguageService } from '@shared/services/language.service';
import { TokenSessionService } from '@shared/services/token.session.service';

@Injectable({
  providedIn: 'root'
})
export class AlarmsService {

  constructor(private httpClient: HttpClient, private languageService: LanguageService, private tokenSessionService: TokenSessionService) { }

  public getAlarmLostFluid(alarmId: string): Observable<any>{
    return this.httpClient.get(`${document.location.protocol}//${document.location.hostname}${environment.apiPort}/${ this.languageService.currentLanguage}/alarms/${encodeURIComponent(alarmId)}/lost-fluid`, {
      headers: {
        Authorization: `Bearer ${this.tokenSessionService.getToken()}`
      }
    });
  }
}
